import React from 'react';
import HowItWorksHeaderIcon from 'components/IconModule/icons/howItWorksHeader';
import css from './Heading.module.scss';
import cn from 'classnames';
import { Breadcrumb } from 'antd';
import { Link } from 'react-router-dom';

import homeIcon from 'static/img/a_level/home.svg';
import divider from 'static/img/a_level/divider.svg';
import { useTranslation } from 'react-i18next';

const renderBreadcrumb = (text: string) => {
  return (
    <Breadcrumb
      separator={<img src={divider} alt="" />}
      className={css.breadcrumb}
    >
      <Breadcrumb.Item>
        <Link to="/">
          <img src={homeIcon} alt="" />
        </Link>
      </Breadcrumb.Item>
      <Breadcrumb.Item>
        <span
          className={cn({
            link: true
          })}
        >
          {text}
        </span>
      </Breadcrumb.Item>
    </Breadcrumb>
  );
};

export default function Heading() {
  const { t } = useTranslation()
  const header = (
    <div className={css.header}>
      <span className={css.topText}>
        <span>{t('How it all')}&nbsp;</span>
        <span className={css.purple}>{t('works')}</span>
      </span>
    </div>
  );
  return (
    <section className={css.wrapper}>
      <div className={css.breadcrumb}>{renderBreadcrumb(t('How it Works'))}</div>
      <div className={css.infoBlock}>
        <div className={css.mainBlock}>
          <div className={css.headerTitle}>
            {header}
          </div>
          <div className={css.description}>
            <p>{t('Everything you need to know about finding a tutor, bookings, payments & reviews')}</p>
          </div>
        </div>
        <HowItWorksHeaderIcon className={css.icon} />
      </div>
    </section>
  );
}
